module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-tabs', {
    staticClass: "tabs",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "all",
      "title": "全部"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "good",
      "title": "精华"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "share",
      "title": "分享"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "ask",
      "title": "问答"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "job",
      "title": "招聘"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-315a71e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/m-nav.vue
// module id = 153
// module chunks = 2